import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

export const StatusSwitch = withStyles({
  switchBase: {
    '&$checked': {
      color: '#003f56',
    },
    '&$checked + $track': {
      backgroundColor: '#003f56',
    },
  },
  checked: {},
  track: {},
})(Switch);
